import React, { Component } from "react";
import * as d3 from "d3";
import styled from "styled-components";
import { connect } from "react-redux";

import { devices, getDevice } from "../../services/getDevice";

const GraphContainer = styled.div`
  width: 100%;
  height: 250px;
  text-align: center;
  margin: auto;

  text {
    fill: ${props => props.theme.textHighlight};
  }

  .main-bubble-cells circle {
    cursor: pointer;
    fill: rgba(46, 112, 116, 0.7);
    stroke: #2e7074;
    stroke-width: 1px;

    :hover {
      stroke-width: 3px;
    }
  }

  .bubble-axis path,
  .bubble-axis line,
  .bubble-central-axis line,
  .bubble-central-axis path {
    fill: none;
    stroke: #1b567a;
    stroke-width: 1px;
    stroke-dasharray: 1.5 2;
  }

  /* Remove axis markings */
  .bubble-axis text,
  .bubble-central-axis text {
    display: none;
  }

  .bubble-percentageValue {
    font-size: 9px;
  }

  .bubble-counts text {
    font-size: 15px;
  }

  .bubble-counts .small {
    font-size: 10px;
  }

  @media (min-width: 1800px) {
    width: 80%;
    height: 320px;

    .bubble-percentageValue {
      font-size: 16px;
    }
    .bubble-counts text {
      font-size: 20px;
    }

    .bubble-counts .small {
      font-size: 12px;
    }

    .bubble-axis path,
    .bubble-axis line,
    .bubble-central-axis line,
    .bubble-central-axis path {
      stroke-width: 2px;
      stroke-dasharray: 2.55 3.39;
    }
  }

  @media (max-width: 575px) {
    height: 200px;

    .bubble-percentageValue {
      font-size: 10px;
    }
    .bubble-axis path,
    .bubble-axis line,
    .bubble-central-axis line,
    .bubble-central-axis path {
      stroke-width: 1px;
      stroke-dasharray: 2.55 3.39;
    }

    .bubble-counts text {
      font-size: 18px;
    }
  }
`;

class MainServicesGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          id: 0,
          value: 5,
          radius: 10,
          entity: "Bytrex"
        },
        {
          id: 1,
          value: 20,
          radius: 20,
          entity: "Buzzness"
        },
        {
          id: 2,
          value: 80,
          radius: 30,
          entity: "Ramjob"
        },
        {
          id: 3,
          value: 56,
          radius: 40,
          entity: "Parcoe"
        },
        {
          id: 4,
          value: 25,
          radius: 50,
          entity: "Kengen"
        },
        {
          id: 5,
          value: 50,
          radius: 40,
          entity: "Digial"
        },
        {
          id: 6,
          value: 12,
          radius: 60,
          entity: "Sealoud"
        },
        {
          id: 7,
          value: 75,
          radius: 80,
          entity: "Zoid"
        },
        {
          id: 8,
          value: 30,
          radius: 100,
          entity: "Interodeo"
        }
      ]
    };
  }

  componentDidMount() {
    this.drawGraph();
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      this.drawGraph();
    }
  }

  drawGraph = () => {
    let { data } = this.state;

    data = data.sort(function(a, b) {
      return b.radius - a.radius;
    });

    console.table(data);

    let { onServiceFilter } = this.props;
    var container = d3.select(this.graph);

    let containerWidth = container.node().getBoundingClientRect().width,
      containerHeight = container.node().getBoundingClientRect().height;
    var marginSets = {
      desktop: { top: 10, right: 55, bottom: 10, left: 55 },
      mobile: { top: 10, right: 25, bottom: 10, left: 25 }
    };
    var margin =
        window.innerWidth < 575 ? marginSets.mobile : marginSets.desktop,
      tickSizeTop = 20,
      width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom,
      circleMax = 70,
      circleMin = 5;

    // For Screenwidth > 1800px
    if (window.innerWidth > 1800) {
      circleMax = 100;
      circleMin = 7.5;
    } else if (window.innerWidth < 575) {
      circleMax = 41;
      circleMin = 3.5;
    }

    //Remove Previous
    container.select("svg").remove();

    var svg = container
      .append("svg")
      .attr("width", width + margin.right + margin.left)
      .attr("height", height + margin.top + margin.bottom);

    var formatValue = d3.format(",d");

    var x = d3
      .scaleLinear()
      .rangeRound([0, width])
      .domain([0, 100]);

    var radius = d3
      .scaleLinear()
      .domain([
        d3.min(data, function(d) {
          return d.radius;
        }),
        d3.max(data, function(d) {
          return d.radius;
        })
      ])
      .range([circleMin, circleMax]);

    var g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    //Find count in each bracket
    var countData = [0, 0, 0, 0, 0];

    data.map(item => {
      if (item.value <= 20) {
        countData[0] += 1;
      } else if (item.value > 20 && item.value <= 40) {
        countData[1] += 1;
      } else if (item.value > 40 && item.value <= 60) {
        countData[2] += 1;
      } else if (item.value > 60 && item.value <= 80) {
        countData[3] += 1;
      } else if (item.value > 80 && item.value <= 100) {
        countData[4] += 1;
      }
    });

    // Top axis
    g.append("g")
      .attr("class", "bubble-axis axis--x")
      .attr("transform", "translate(0,0)")
      .call(
        d3
          .axisBottom(x)
          .ticks(5)
          .tickSize(20)
      );

    // Central axis
    g.append("g")
      .attr("class", "bubble-central-axis")
      .attr("transform", "translate(0," + (height / 2 + tickSizeTop) + ")")
      .call(
        d3
          .axisTop(x)
          .ticks(1)
          .tickSize(15)
      );

    g.append("g")
      .attr("class", "bubble-central-axis")
      .attr("transform", "translate(0," + (height / 2 + tickSizeTop) + ")")
      .call(
        d3
          .axisBottom(x)
          .ticks(1)
          .tickSize(15)
      );

    //Percentage Labels
    var zeroPerText = g
      .append("text")
      .attr("class", "bubble-percentageValue")
      .attr("text-anchor", "end")
      .attr("dominant-baseline", "central")
      .text("0%")
      .attr("x", -10)
      .attr("y", height / 2 + tickSizeTop);

    var hundredPerText = g
      .append("text")
      .attr("class", "bubble-percentageValue")
      .attr("text-anchor", "start")
      .attr("dominant-baseline", "central")
      .text("100%")
      .attr("x", width + 10)
      .attr("y", height / 2 + tickSizeTop);

    if (getDevice() === devices.mobile) {
      zeroPerText
        .attr("text-anchor", "middle")
        .attr("transform", "rotate(90,-10," + (height / 2 + tickSizeTop) + ")");

      hundredPerText
        .attr("text-anchor", "middle")
        .attr(
          "transform",
          "rotate(90," + (width + 10) + "," + +(height / 2 + tickSizeTop) + ")"
        );
    }

    //Counts in each bracket
    var countTexts = g
      .append("g")
      .attr("class", "bubble-counts")
      .selectAll("g")
      .data(countData);

    const stepWidth = width / 5;

    countTexts
      .enter()
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("x", function(d, i) {
        return stepWidth / 2 + i * stepWidth;
      })
      .attr("y", 15)
      .text(function(d) {
        return d;
      });

    countTexts
      .enter()
      .append("text")
      .attr("class", "small")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("x", function(d, i) {
        return stepWidth / 2 + i * stepWidth;
      })
      .attr("y", 30)
      .text("خــدمــة");

    // Plotting the circles in graph
    var cell = g
      .append("g")
      .attr("class", "main-bubble-cells")
      .selectAll("g")
      .data(data)
      .enter()
      .append("g");

    cell
      .append("circle")
      .attr("r", function(d) {
        return radius(d.radius);
      })
      .attr("cx", function(d) {
        return x(d.value);
      })
      .attr("cy", function(d) {
        return height / 2 + tickSizeTop;
      })
      .on("click", function() {
        onServiceFilter();
      });

    cell.append("title").text(function(d) {
      return d.entity + "\n" + formatValue(d.radius);
    });
  };

  render() {
    return <GraphContainer ref={el => (this.graph = el)} className="graph" />;
  }
}

const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  null
)(MainServicesGraph);
